import React, { useState } from "react";
import styles from "./FAQ.module.scss";
import { Textarea } from "../../../components/Textarea/Textarea";
import { Button } from "../../../ui/Button/Button";
import { TrashIcon } from "../../../../../assets/icons/TrashIcon";
import { useDispatch, useSelector } from "react-redux";
import { setNewAssistant } from "../../../../../store/slices/assistantSlice";

const FAQBlock = ({ data, onChange, onDelete }) => {
  return (
    <div className={styles.blockWrapper}>
      <div className={styles.delete} onClick={onDelete}>
        <TrashIcon fill="red" />
      </div>
      <div className={styles.textareaContainer}>
        <Textarea
          placeholder="Вопрос"
          value={data.question}
          onChange={(e) => onChange("question", e.target.value)}
        />
        <Textarea
          placeholder="Ответ"
          value={data.answer}
          onChange={(e) => onChange("answer", e.target.value)}
        />
      </div>
    </div>
  );
};

export const FAQ = () => {
  const dispatch = useDispatch();
  const assistant = useSelector((state) => state?.assistant?.newAssistant);

  // Инициализация состояния один раз из Redux
  const [blocks, setBlocks] = useState(() => {
    return assistant?.faq?.length > 0
      ? assistant.faq
      : [{ question: "", answer: "" }];
  });

  const updateFAQInRedux = (newBlocks) => {
    setBlocks(newBlocks);
    dispatch(setNewAssistant({ ...assistant, faq: newBlocks }));
  };

  const createNewBlock = () => {
    const updated = [...blocks, { question: "", answer: "" }];
    updateFAQInRedux(updated);
  };

  const handleBlockChange = (index, field, value) => {
    const updated = blocks.map((block, i) =>
      i === index ? { ...block, [field]: value } : block
    );
    updateFAQInRedux(updated);
  };

  const deleteBlock = (index) => {
    const updated = blocks.filter((_, i) => i !== index);
    updateFAQInRedux(updated);
  };

  return (
    <div className={styles.container}>
      <div className={styles.faqWrapper}>
        {blocks.map((block, index) => (
          <FAQBlock
            key={index}
            data={block}
            onChange={(field, value) => handleBlockChange(index, field, value)}
            onDelete={() => deleteBlock(index)}
          />
        ))}
      </div>
      <div className={styles.buttonContainer}>
        <Button title="Добавить" onClick={createNewBlock} />
      </div>
    </div>
  );
};
